/**
 * Posicionamiento de tarjetas de hotspot (carousel + modal Shop the Look).
 * @param {Element} hotspot
 * @param {string} figureSelector - ej. '.lop-shop-the-look-carousel__figure' | '.lop-stl-modal__figure'
 */
function lopStlUpdateHotspotCardPosition(hotspot, figureSelector) {
  var figure = hotspot && hotspot.closest(figureSelector);
  if (!figure) return;

  var PAD = 8;
  var CARD_PIN_GAP = 10;
  var CARD_PIN_GAP_ABOVE = 6;
  var CARD_W_DEFAULT = 140;
  var CARD_H_DEFAULT = 210;
  var CARD_W_LARGE = 160;
  var CARD_H_LARGE = 230;

  var cardEl = hotspot.querySelector('.lop-hotspot__card');
  var cardW = cardEl ? cardEl.offsetWidth : (window.innerWidth >= 1440 ? CARD_W_LARGE : CARD_W_DEFAULT);
  var cardH = cardEl ? cardEl.offsetHeight : (window.innerWidth >= 1440 ? CARD_H_LARGE : CARD_H_DEFAULT);
  var fr = figure.getBoundingClientRect();
  var fLeft = fr.left + PAD;
  var fTop = fr.top + PAD;
  var fRight = fr.right - PAD;
  var fBottom = fr.bottom - PAD;
  var hr = hotspot.getBoundingClientRect();
  var pinCenterX = hr.left + hr.width / 2;
  var pinCenterY = hr.top + hr.height / 2;
  var pinBottom = hr.bottom;
  var pinTop = hr.top;
  var pinLeft = hr.left;
  var pinRight = hr.right;

  function clamp(v, minV, maxV) {
    return Math.max(minV, Math.min(maxV, v));
  }

  var fitsBelow = Math.max(fTop, pinBottom + CARD_PIN_GAP) <= fBottom - cardH;
  var fitsAbove = fTop <= Math.min(fBottom - cardH, pinTop - CARD_PIN_GAP_ABOVE - cardH);
  var fitsLeft = fLeft <= Math.min(fRight - cardW, pinLeft - CARD_PIN_GAP - cardW);
  var fitsRight = Math.max(fLeft, pinRight + CARD_PIN_GAP) <= fRight - cardW;

  var placement = 'below';
  var cardLeft = pinCenterX - cardW / 2;
  var cardTop = pinBottom + CARD_PIN_GAP;
  if (fitsBelow) {
    placement = 'below';
    cardLeft = pinCenterX - cardW / 2;
    cardTop = pinBottom + CARD_PIN_GAP;
  } else if (fitsAbove) {
    placement = 'above';
    cardLeft = pinCenterX - cardW / 2;
    cardTop = pinTop - CARD_PIN_GAP_ABOVE - cardH;
  } else if (fitsLeft) {
    placement = 'left';
    cardLeft = pinLeft - CARD_PIN_GAP - cardW;
    cardTop = pinCenterY - cardH / 2;
  } else if (fitsRight) {
    placement = 'right';
    cardLeft = pinRight + CARD_PIN_GAP;
    cardTop = pinCenterY - cardH / 2;
  } else {
    placement = 'below';
    cardLeft = pinCenterX - cardW / 2;
    cardTop = pinBottom + CARD_PIN_GAP;
  }

  if (placement === 'above') {
    cardTop = clamp(
      pinTop - CARD_PIN_GAP_ABOVE - cardH,
      fTop,
      Math.min(fBottom - cardH, pinTop - CARD_PIN_GAP_ABOVE - cardH)
    );
    cardLeft = clamp(pinCenterX - cardW / 2, fLeft, fRight - cardW);
  } else if (placement === 'below') {
    cardLeft = clamp(pinCenterX - cardW / 2, fLeft, fRight - cardW);
    cardTop = clamp(
      pinBottom + CARD_PIN_GAP,
      Math.max(fTop, pinBottom + CARD_PIN_GAP),
      fBottom - cardH
    );
  } else if (placement === 'left') {
    cardLeft = clamp(
      pinLeft - CARD_PIN_GAP - cardW,
      fLeft,
      Math.min(fRight - cardW, pinLeft - CARD_PIN_GAP - cardW)
    );
    cardTop = clamp(pinCenterY - cardH / 2, fTop, fBottom - cardH);
  } else {
    cardLeft = clamp(
      pinRight + CARD_PIN_GAP,
      Math.max(fLeft, pinRight + CARD_PIN_GAP),
      fRight - cardW
    );
    cardTop = clamp(pinCenterY - cardH / 2, fTop, fBottom - cardH);
  }

  var tx = 0;
  var ty = 0;
  if (placement === 'below') {
    tx = cardLeft - (pinCenterX - cardW / 2);
    ty = cardTop - (pinBottom + CARD_PIN_GAP);
  } else if (placement === 'above') {
    tx = cardLeft - (pinCenterX - cardW / 2);
    ty = cardTop - (pinTop - CARD_PIN_GAP_ABOVE - cardH);
  } else if (placement === 'left') {
    tx = cardLeft - (pinLeft - CARD_PIN_GAP - cardW);
    ty = cardTop - (pinCenterY - cardH / 2);
  } else {
    tx = cardLeft - (pinRight + CARD_PIN_GAP);
    ty = cardTop - (pinCenterY - cardH / 2);
  }

  var lopCardOffsetPx = placement === 'above' ? CARD_PIN_GAP_ABOVE : CARD_PIN_GAP;
  hotspot.setAttribute('data-card-placement', placement);
  hotspot.style.setProperty('--card-translate-x', tx + 'px');
  hotspot.style.setProperty('--card-translate-y', ty + 'px');
  hotspot.style.setProperty('--lop-card-offset', lopCardOffsetPx + 'px');

  if (cardEl) {
    var offsetVal = lopCardOffsetPx + 'px';
    if (placement === 'below') {
      cardEl.style.top = 'calc(100% + ' + offsetVal + ')';
      cardEl.style.bottom = cardEl.style.left = cardEl.style.right = '';
    } else if (placement === 'above') {
      cardEl.style.bottom = 'calc(100% + ' + offsetVal + ')';
      cardEl.style.top = cardEl.style.left = cardEl.style.right = '';
    } else if (placement === 'left') {
      cardEl.style.right = 'calc(100% + ' + offsetVal + ')';
      cardEl.style.left = cardEl.style.top = cardEl.style.bottom = '';
    } else {
      cardEl.style.left = 'calc(100% + ' + offsetVal + ')';
      cardEl.style.right = cardEl.style.top = cardEl.style.bottom = '';
    }
  }
}
